import React, {Component, useState, useCallback} from 'react';
import ParameterButton from './ParameterButton.js';
import SimpleParameterSlider from './SimpleParameterSlider.js';
import ParameterModulators from 'components/effects/ParameterModulators.js';

export default class MultiParameterSlider extends Component {
    constructor(props) {
        super(props);

        let {parameters} = props;
        let names = Object.keys(parameters);
        let firstParameter = parameters[names[0]];
        this.state = {
            selectedParameter: firstParameter,
        };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.parameters !== this.props.parameters) {
            let {parameters} = nextProps;
            let names = Object.keys(parameters);
            let firstParameter = parameters[names[0]];
            this.state.selectedParameter = firstParameter;
        }
        return true;
    }

    onSelect(s) {
        this.setState({selectedParameter: s});
    }

    onChangeValue (e) {
        this.state.selectedParameter.parameter.set(Math.pow(e.target.value, 3));
    }

    render() {
        let {parameters} = this.props;
        let showMods = this.props.showMods === undefined ?
            true : this.props.showMods;
        let names = Object.keys(parameters);
        return (
            <div className="multiple-parameter-slider">
              <div className="parameters">
                {names.map(
                    (name, i) =>
                        <ParameterButton
                              key={"parameter-" + i}
                              isSelected={parameters[name] === this.state.selectedParameter}
                              onClick={(s) => this.onSelect(s)}
                              name={name}
                              parameter={parameters[name]}
                          />)}
            </div>
                <div className="slider-and-modulators">
                <SimpleParameterSlider
                  onChange={(e) => this.onChangeValue(e)}
                  parameter={this.state.selectedParameter}/>
            {showMods ? 
                <ParameterModulators
                  sequencerEngine={this.props.sequencerEngine}
                  parameter={this.state.selectedParameter.parameter}/> : ''}
                </div>
         </div>
        );
    }
}

